export default __webpack_public_path__ + "static/media/Exede_Mobile-UI-Kit.82e76c17.jpg";